module.exports = __webpack_public_path__ + "static/media/muscleaider-3.114abad4.png";